import { useEffect, useRef } from "react";

const Cursor = () => {
  const dotRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    if (!dot) return;

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let tx = x;
    let ty = y;

    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;
    };

    const onOver = (e) => {
      const t = e.target;
      if (
        t.closest(
          "a, button, input, textarea, [role='button'], .ifgl-hover"
        )
      ) {
        dot.classList.add("hover");
      } else {
        dot.classList.remove("hover");
      }
    };

    const tick = () => {
      x += (tx - x) * 0.35;
      y += (ty - y) * 0.35;
      dot.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(tick);
    };

    let raf = requestAnimationFrame(tick);
    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });

    // Hide cursor when leaving viewport
    const onLeave = () => (dot.style.opacity = "0");
    const onEnter = () => (dot.style.opacity = "1");
    document.addEventListener("mouseleave", onLeave);
    document.addEventListener("mouseenter", onEnter);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseleave", onLeave);
      document.removeEventListener("mouseenter", onEnter);
    };
  }, []);

  // Hide on touch devices
  if (typeof window !== "undefined" && "ontouchstart" in window) {
    return null;
  }

  return <div ref={dotRef} className="ifgl-cursor" data-testid="custom-cursor" />;
};

export default Cursor;
